import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserAuthService } from '../UserAuth.service';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(UserAuthService);
  const router = inject(Router);

  if (authService.hasRole('administrator') || authService.hasRole('SuperAdmin')) {
    return true;
  }

  router.navigate(['/admin/preferences']);
  return false;
};
